import { GoalMetricOption } from '@amzn/aet-galactus-kit';

export const GoalMetricDefaultName = new Map<string, [string, string]>([
  [GoalMetricOption.RAP.toString(), ['cs_perfportal_rap', 'RAP']],
  [GoalMetricOption.CCX.toString(), ['cs_perfportal_ccx', 'CCX']],
  [GoalMetricOption.FCR.toString(), ['cs_perfportal_fcr', 'FCR']],
  [GoalMetricOption.DSR.toString(), ['cs_perfportal_dsr', 'DSR']],
  [GoalMetricOption.DCR.toString(), ['cs_perfportal_dcr', 'DCR']],
  [
    GoalMetricOption.POLICY_ADHERENCE.toString(),
    ['cs_perfportal_pa', 'Policy Adherence'],
  ],
  [
    GoalMetricOption.CONCESSION_RATE.toString(),
    ['cs_perfportal_concessionRate', 'Concession Rate'],
  ],
  [GoalMetricOption.DART.toString(), ['cs_perfportal_dart', 'DART']],
  [
    GoalMetricOption.TRANSFER_RATE.toString(),
    ['cs_perfportal_tr', 'Transfer Rate'],
  ],
  [GoalMetricOption.ACHT.toString(), ['cs_perfportal_acht', 'ACHT']],
  [
    GoalMetricOption.HOLD_TIME.toString(),
    ['cs_perfportal_hold_time', 'Hold Time'],
  ],
  [
    GoalMetricOption.CCX_NEG_ONEBOX.toString(),
    ['cs_perfportal_ccx_bottom_onebox', 'CCX Overall Service (Bottom Box)'],
  ],
  [
    GoalMetricOption.CCX_NEG.toString(),
    ['cs_perfportal_ccx_bottombox', 'CCX Overall Service (Bottom-Two Box)'],
  ],
  [
    GoalMetricOption.UNDERSTANDABILITY.toString(),
    ['cs_perfportal_lighthouse_ccx_understandability', 'CCX-Understandability'],
  ],
  [
    GoalMetricOption.INVALID_DART_ESCALATION_RATE.toString(),
    ['cs_perfportal_invalid_dart_escalation', 'Invalid DART Escalation'],
  ],
  [
    GoalMetricOption.INVALID_TRANSFER_RATE.toString(),
    ['cs_perfporal_invalid_transfer', 'Invalid Transfer'],
  ],
  [
    GoalMetricOption.HIGH_SILENCE_RATE.toString(),
    ['cs_perfporal_high_silence', 'High Silence'],
  ],
  [
    GoalMetricOption.EMPATHY.toString(),
    ['cs_perfporal_ccx_empathy', 'CCX-Empathy'],
  ],
  [
    GoalMetricOption.COURTESY.toString(),
    ['cs_perfporal_ccx_courtesy', 'CCX-Courtesy'],
  ],
  [
    GoalMetricOption.KNOWLEDGEABLE.toString(),
    ['cs_perfporal_ccx_knowledgeable', 'CCX-Knowledgeable'],
  ],
  [
    GoalMetricOption.HELPFULNESS.toString(),
    ['cs_perfporal_ccx_helpfulness', 'CCX-Helpfulness'],
  ],
  [
    GoalMetricOption.EFFICIENCY.toString(),
    ['cs_perfporal_ccx_efficiency', 'CCX-Efficiency'],
  ],
  [
    GoalMetricOption.EMPATHY_NEG_ONEBOX.toString(),
    ['cs_perfporal_ccx_bot_box_empathy', 'Bottom-box CCX-Empathy'],
  ],
  [
    GoalMetricOption.COURTESY_NEG_ONEBOX.toString(),
    ['cs_perfporal_ccx_bot_box_courtesy', 'Bottom-box CCX-Courtesy'],
  ],
  [
    GoalMetricOption.KNOWLEDGEABLE_NEG_ONEBOX.toString(),
    ['cs_perfporal_ccx_bot_box_knowledgeable', 'Bottom-box CCX-Knowledgeable'],
  ],
  [
    GoalMetricOption.UNDERSTANDABILITY_NEG_ONEBOX.toString(),
    [
      'cs_perfporal_ccx_bot_box_understandability',
      'Bottom-box CCX-Understandability',
    ],
  ],
  [
    GoalMetricOption.HELPFULNESS_NEG_ONEBOX.toString(),
    ['cs_perfporal_ccx_bot_box_helpfulness', 'Bottom-box CCX-Helpfulness'],
  ],
  [
    GoalMetricOption.EFFICIENCY_NEG_ONEBOX.toString(),
    ['cs_perfporal_ccx_bot_box_efficiency', 'Bottom-box CCX-Efficiency'],
  ],
  [
    GoalMetricOption.EMPATHY_NEG.toString(),
    ['cs_perfporal_ccx_bot_box_empathy', 'Bottom-Two box CCX-Empathy'],
  ],
  [
    GoalMetricOption.COURTESY_NEG.toString(),
    ['cs_perfporal_ccx_bot_box_courtesy', 'Bottom-Two box CCX-Courtesy'],
  ],
  [
    GoalMetricOption.KNOWLEDGEABLE_NEG.toString(),
    [
      'cs_perfporal_ccx_bot_box_knowledgeable',
      'Bottom-Two box CCX-Knowledgeable',
    ],
  ],
  [
    GoalMetricOption.UNDERSTANDABILITY_NEG.toString(),
    [
      'cs_perfporal_ccx_bot_box_understandability',
      'Bottom-Two box CCX-Understandability',
    ],
  ],
  [
    GoalMetricOption.HELPFULNESS_NEG.toString(),
    ['cs_perfporal_ccx_bot_box_helpfulness', 'Bottom-Two box CCX-Helpfulness'],
  ],
  [
    GoalMetricOption.EFFICIENCY_NEG.toString(),
    ['cs_perfporal_ccx_bot_box_efficiency', 'Bottom-Two box CCX-Efficiency'],
  ],
]);
